import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_AngerManagementAssessment = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='HFI_AngerManagementAssessment' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><h3>DEMOGRAPHICS</h3></p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Name:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>DOB:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtName_1' name='txtName_1' className='add-only'/>
        </td>
        <td className='w-375'>
            <input type='date' id='txtDateBirth_1' name='txtDateBirth_1' className='add-only'/>
        </td>
    </tr>

    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Age:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Gender:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtAge_1' name='txtAge_1' className='add-only'/>
        </td>
        <td className='w-375'>
            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male'/> Male &nbsp;
            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female'/> Female
        </td>
    </tr>
</table>

<p className='w-750'><span className='eleHeader'>Race:</span>
    <input type='radio' id='rbRace_Caucasian' name='rbRace' className='add-only' value='Caucasian'/> Caucasian &nbsp; &nbsp;
    <input type='radio' id='rbRace_AfricanAmerican' name='rbRace' className='add-only' value='AfricanAmerican'/> African American &nbsp; &nbsp;
    <input type='radio' id='rbRace_NativeAmerican ' name='rbRace' className='add-only' value='NativeAmerican'/> Native American  &nbsp; &nbsp;
    <input type='radio' id='rbRace_AsianPacific' name='rbRace' className='add-only' value='AsianPacific'/> Asian/Pacific <br />
    <input type='radio' id='rbRace_Other' name='rbRace' className='add-only' value='Other'/> Other &nbsp;
    <input type='text' id='txtRaceOther_1' name='txtRaceOther_1' className='add-only w-375 custom-add-only'/>
</p>

<p className='w-750'><span className='eleHeader'>Address: (Home):</span>
    <input type='text' id='txtAddressHome' name='txtAddressHome' className='add-only'/></p>

<p className='w-750'><span className='eleHeader'>Home Phone:</span>
    <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only'/></p>

<p className='w-750'><span className='eleHeader'>Probation Officer/Court of referral:</span>
    <input type='text' id='txtProbationOfficerCourt' name='txtProbationOfficerCourt' className='add-only'/></p>

<p className='w-750'><span className='eleHeader'>Marital Status:</span>
    <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married'/> Married &nbsp; &nbsp;
    <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single'/> Single &nbsp; &nbsp;
    <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced'/> Divorced  &nbsp; &nbsp;
    <input type='radio' id='rbMaritalStatus_Separated' name='rbMaritalStatus' className='add-only' value='Separated'/> Separated  &nbsp; &nbsp;
</p>
<p className='w-750'><span className='eleHeader'>Living Situation:</span>
    <input type='radio' id='rbLivingSituation_LivePartner' name='rbLivingSituation' className='add-only' value='LivePartner'/> Live with partner  &nbsp; &nbsp;
    <input type='radio' id='rbLivingSituation_LiveAlone' name='rbLivingSituation' className='add-only' value='LiveAlone'/> Live alone &nbsp; &nbsp;
    <input type='radio' id='rbLivingSituation_LiveFamily' name='rbLivingSituation' className='add-only' value='LiveFamily'/> Live w/family    &nbsp; &nbsp;
    <input type='radio' id='rbLivingSituation_Friend' name='rbLivingSituation' className='add-only' value='Friend'/> Friend  &nbsp; &nbsp;
</p>

<p className='w-750'><span className='eleHeader'>How long in current residence?</span>
    <input type='radio' id='rbHowLongInCurrentResidence_Rent' name='rbHowLongInCurrentResidence' className='add-only' value='Rent'/> Rent  &nbsp; &nbsp;
    <input type='text' id='txtHowLongInCurrent_1' name='txtHowLongInCurrent_1' className='add-only w-250 custom-add-only'/> <br />
    <input type='radio' id='rbHowLongInCurrentResidence_Own' name='rbHowLongInCurrentResidence' className='add-only' value='Own'/> Own  &nbsp; &nbsp;
    <input type='text' id='txtHowLongInCurrent_2' name='txtHowLongInCurrent_2' className='add-only w-250 custom-add-only'/>
</p>

<p className='w-750'><span className='eleHeader'>Who lives with client at residence (include names, ages and relationships to client)</span>
    <textarea id='txtWhoLivesWithClientAtResidence' name='txtWhoLivesWithClientAtResidence' className='add-only'></textarea></p>

<p className='w-750'><h4>Dependents:</h4></p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>How many children?</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Spouse:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtHowManyChildren' name='txtHowManyChildren' className='add-only'/></td>
        <td className='w-375'>
            <input type='text' id='txtSpouse' name='txtSpouse' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Other Dependents:</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtOtherDependents' name='txtOtherDependents' className='add-only'/>
        </td>
    </tr>

</table>

<p className='w-750'><h4>EDUCATION</h4></p>

<p className='w-750'><span className='eleHeader'>Highest grade completed:</span>
    <input type='radio' id='rbHighestGradeCompleted_GED' name='rbHighestGradeCompleted' className='add-only' value='GED'/> GED  &nbsp; &nbsp;
    <input type='radio' id='rbHighestGradeCompleted_HS' name='rbHighestGradeCompleted' className='add-only' value='HS'/> HS  &nbsp; &nbsp;
    <input type='radio' id='rbHighestGradeCompleted_Trade' name='rbHighestGradeCompleted' className='add-only' value='Trade'/> Trade  &nbsp; &nbsp;
    <input type='radio' id='rbHighestGradeCompleted_SomeCollege' name='rbHighestGradeCompleted' className='add-only' value='Some College'/> Some College   &nbsp; &nbsp;
    <input type='radio' id='rbHighestGradeCompleted_CollegeDegree' name='rbHighestGradeCompleted' className='add-only' value='College/Degree'/> College/Degree  <br />

    <span className='eleHeader'>If drop out, why:</span>
    <textarea id='txtIfDropOutWhy' name='txtIfDropOutWhy' className='add-only'></textarea>  <br />

    <span className='eleHeader'>Can client read and write:</span>
    <input type='radio' id='rbCanClientReadAnd_Yes' name='rbCanClientReadAnd' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbCanClientReadAnd_No' name='rbCanClientReadAnd' className='add-only' value='No'/> No
</p>

<p className='w-750'><h4>EMPLOYMENT</h4></p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Current Employer:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Phone:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtCurrentEmployer' name='txtCurrentEmployer' className='add-only'/>
        </td>
        <td className='w-375'>
            <input type='date' id='txtPhone_1' name='txtPhone_1' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Address</span></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Current Job Title:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Length of Employment:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtCurrentJobTitle' name='txtCurrentJobTitle' className='add-only'/>
        </td>
        <td className='w-375'>
            <input type='date' id='txtLengthOfEmployment' name='txtLengthOfEmployment' className='add-only'/>
        </td>
    </tr>
</table>

<p className='w-750'><h4>MEDICAL/HEALTH</h4></p>


<p className='w-750'><span className='eleHeader'>Do you have any ongoing health problems?:</span>
    <input type='radio' id='rbDoYouHaveAnyOngoingHealthProblems_Yes' name='rbDoYouHaveAnyOngoingHealthProblems' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDoYouHaveAnyOngoingHealthProblems_No' name='rbDoYouHaveAnyOngoingHealthProblems' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, please explain:</span>
    <textarea id='txtIfYesPleaseExplain' name='txtIfYesPleaseExplain' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Are you currently taking any medications?</span>
    <input type='radio' id='rbAreYouCurrentlyTakingAnyMedications_Yes' name='rbAreYouCurrentlyTakingAnyMedications' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbAreYouCurrentlyTakingAnyMedications_No' name='rbAreYouCurrentlyTakingAnyMedications' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, what are you taking:</span>
    <textarea id='txtIfYesWhatTaking' name='txtIfYesWhatTaking' className='add-only'></textarea>
</p>

<p className='w-750'><h4>PSYCHIATRIC STATUS</h4></p>

<p className='w-750'><span className='eleHeader'>Have you ever been treated for psychological or emotional problems?</span>
    <input type='radio' id='rbHaveEverTreatedPsychologicalEmotional_Yes' name='rbHaveEverTreatedPsychologicalEmotional' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveEverTreatedPsychologicalEmotional_No' name='rbHaveEverTreatedPsychologicalEmotional' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, for what were you being treated</span>
    <textarea id='txtIfYesForWhatWereBeingTreated' name='txtIfYesForWhatWereBeingTreated' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>How long ago did you receive counseling or treatment?</span>
    <textarea id='txtHowLongAgoDidYouReceiveCounselingTreatment' name='txtHowLongAgoDidYouReceiveCounselingTreatment' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Did you complete the program: </span>
    <input type='radio' id='rbDidYouCompleteTheProgram_Yes' name='rbDidYouCompleteTheProgram' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDidYouCompleteTheProgram_No' name='rbDidYouCompleteTheProgram' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If no, why not?</span>
    <textarea id='txtIfNowhyNot' name='txtIfNowhyNot' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced serious depression, sadness, hopelessness, loss of interest, difficulty with daily functions, in the past 30 days or in your life time: </span>
    <input type='radio' id='rbHaveYouExperiencedSeriousDepression_Yes' name='rbHaveYouExperiencedSeriousDepression' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedSeriousDepression_No' name='rbHaveYouExperiencedSeriousDepression' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain: </span>
    <textarea id='txtIfYesExplain' name='txtIfYesExplain' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced serious anxiety, tension, up-tightness, stress, unreasonably worried, inability to relax? </span>
    <input type='radio' id='rbHaveYouExperiencedSeriousAnxiety_Yes' name='rbHaveYouExperiencedSeriousAnxiety' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedSeriousAnxiety_No' name='rbHaveYouExperiencedSeriousAnxiety' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain when was the last time and how often does this occur</span>
    <textarea id='txtIfYesLastTimeThisOccur' name='txtIfYesLastTimeThisOccur' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced hallucinations-saw things or heard voices that were not there? </span>
    <input type='radio' id='rbHaveYouExperiencedHallucinations_Yes' name='rbHaveYouExperiencedHallucinations' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedHallucinations_No' name='rbHaveYouExperiencedHallucinations' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>When was the last time you experienced hallucinations?</span>
    <textarea id='txtwhenWasTheLastTimeYouExperienced' name='txtwhenWasTheLastTimeYouExperienced' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced trouble understanding, concentrating, or remembering? </span>
    <input type='radio' id='rbHaveYouExperiencedTroubleUnderstanding_Yes' name='rbHaveYouExperiencedTroubleUnderstanding' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedTroubleUnderstanding_No' name='rbHaveYouExperiencedTroubleUnderstanding' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_1' name='txtIfYesExplain_1' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced trouble controlling violent behavior, including episodes of rage or violence? </span>
    <input type='radio' id='rbHaveYouExperiencedTroubleControlling_Yes' name='rbHaveYouExperiencedTroubleControlling' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedTroubleControlling_No' name='rbHaveYouExperiencedTroubleControlling' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>When was the last time this occurred?</span>
    <textarea id='txtWhenWasTheLastThisOccurred' name='txtWhenWasTheLastThisOccurred' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>What usually triggers this behavior? </span>
    <textarea id='txtWhatUsuallyTriggersThisBehavior' name='txtWhatUsuallyTriggersThisBehavior' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you experienced thoughts of suicide in the past 30 days or in your life time?</span>
    <input type='radio' id='rbHaveYouExperiencedThoughtsOfSuicide_Yes' name='rbHaveYouExperiencedThoughtsOfSuicide' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouExperiencedThoughtsOfSuicide_No' name='rbHaveYouExperiencedThoughtsOfSuicide' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_2' name='txtIfYesExplain_2' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Do you feel suicidal today? </span>
    <input type='radio' id='rbDoYouFeelSuicidalToday_Yes' name='rbDoYouFeelSuicidalToday' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDoYouFeelSuicidalToday_No' name='rbDoYouFeelSuicidalToday' className='add-only' value='No'/> No <br />

    If yes, do you have a plan? &nbsp;
    <input type='radio' id='rbDoYouHavePlan_Yes' name='rbDoYouHavePlan' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDoYouHavePlan_No' name='rbDoYouHavePlan' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, describe your plan:</span>
    <textarea id='txtIfYesDescribePlan' name='txtIfYesDescribePlan' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you ever attempted suicide? </span>
    <input type='radio' id='rbHaveYouEverAttemptedSuicide_Yes' name='rbHaveYouEverAttemptedSuicide' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouEverAttemptedSuicide_No' name='rbHaveYouEverAttemptedSuicide' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_3' name='txtIfYesExplain_3' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you felt like hurting others or committing homicide?</span>
    <input type='radio' id='rbHaveYouFeltLikeHurtingOtherHomicide_Yes' name='rbHaveYouFeltLikeHurtingOtherHomicide' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouFeltLikeHurtingOtherHomicide_No' name='rbHaveYouFeltLikeHurtingOtherHomicide' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, whom did you want to hurt and what were the reasons?</span>
    <textarea id='txtIfYesWhomDidYouWantHurtWereReasons' name='txtIfYesWhomDidYouWantHurtWereReasons' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Have you ever been prescribed medication(s) for any psychological  or emotional problems? </span>
    <input type='radio' id='rbHaveYouEverBeenPrescribedMedication_Yes' name='rbHaveYouEverBeenPrescribedMedication' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouEverBeenPrescribedMedication_No' name='rbHaveYouEverBeenPrescribedMedication' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, for what was the medication prescribed?</span>
    <textarea id='txtIfYesForWhatWasTheMedicationPrescribed' name='txtIfYesForWhatWasTheMedicationPrescribed' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Was the treatment successful?</span>
    <input type='radio' id='rbWasTheTreatmentSuccessFul_Yes' name='rbWasTheTreatmentSuccessFul' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWasTheTreatmentSuccessFul_No' name='rbWasTheTreatmentSuccessFul' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>Explain</span>
    <textarea id='txtExplain' name='txtExplain' className='add-only'></textarea>
</p>


<p className='w-750'><h4>ALCOHOL AND DRUG HISTORY</h4></p>

<p className='w-750'>
    <span className='eleHeader'>At what age did you have your first drink of alcohol and/or drugs?</span>
    <textarea id='txtAtWhatAgeDidYouHaveFirst' name='txtAtWhatAgeDidYouHaveFirst' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Do you currently drink alcohol and/or use drugs? </span>
    <input type='radio' id='rbDoYouCurrentlyDrinkAlcohol_Yes' name='rbDoYouCurrentlyDrinkAlcohol' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDoYouCurrentlyDrinkAlcohol_No' name='rbDoYouCurrentlyDrinkAlcohol' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, what do you use: </span>
    <textarea id='txtIfYesWhatDoUse' name='txtIfYesWhatDoUse' className='add-only'></textarea> <br />

    <span className='eleHeader'>How often do you use and how much?</span>
    <textarea id='txtHowOftenDoYouUseHowMuch' name='txtHowOftenDoYouUseHowMuch' className='add-only'></textarea> <br />

    <span className='eleHeader'>For what reasons did you quit?</span>
    <textarea id='txtForWhatReasonsDidYouQuit' name='txtForWhatReasonsDidYouQuit' className='add-only'></textarea>

</p>

<p className='w-750'><span className='eleHeader'>Have you ever received treatment for alcohol or drug abuse/dependence?</span>
    <input type='radio' id='rbHaveYouEverReceivedAlcoholDrugDependence_Yes' name='rbHaveYouEverReceivedAlcoholDrugDependence' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbHaveYouEverReceivedAlcoholDrugDependence_No' name='rbHaveYouEverReceivedAlcoholDrugDependence' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, when and where were you in treatment? </span>
    <textarea id='txtIfYesWhenAndWhereWereTreatment' name='txtIfYesWhenAndWhereWereTreatment' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Did you successfully complete treatment? </span>
    <input type='radio' id='rbDidYouSuccessfullyCompleteTreatment_Yes' name='rbDidYouSuccessfullyCompleteTreatment' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDidYouSuccessfullyCompleteTreatment_No' name='rbDidYouSuccessfullyCompleteTreatment' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If not, why not?</span>
    <textarea id='txtIfNotWhyNot' name='txtIfNotWhyNot' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Are you still abstinent?</span>
    <input type='radio' id='rbAreYouStillAbstinent_Yes' name='rbAreYouStillAbstinent' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbAreYouStillAbstinent_No' name='rbAreYouStillAbstinent' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If no, what triggered your relapse?</span>
    <textarea id='txtIfNoWhatTriggeredRelapse' name='txtIfNoWhatTriggeredRelapse' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Where you drinking and/or using drugs during your most recent abusive episode? </span>
    <input type='radio' id='rbWhereYouDrinkingAbusiveEpisode_Yes' name='rbWhereYouDrinkingAbusiveEpisode' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWhereYouDrinkingAbusiveEpisode_No' name='rbWhereYouDrinkingAbusiveEpisode' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>Is the use of alcohol &/or drugs a problem in your relationship?</span>
    <input type='radio' id='rbIsTheUseOfAlcoholinRelationship_Yes' name='rbIsTheUseOfAlcoholinRelationship' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbIsTheUseOfAlcoholinRelationship_No' name='rbIsTheUseOfAlcoholinRelationship' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>Do you need help for alcohol or drug abuse/dependency problems?</span>
    <input type='radio' id='rbDoYouNeedHelpForAlcoholOrDrug_Yes' name='rbDoYouNeedHelpForAlcoholOrDrug' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDoYouNeedHelpForAlcoholOrDrug_No' name='rbDoYouNeedHelpForAlcoholOrDrug' className='add-only' value='No'/> No <br />

</p>

<p className='w-750'><h4>CHILDHOOD HISTORY</h4></p>

<p className='w-750'><span className='eleHeader'>By who were you raised? </span>
    <input type='radio' id='rbByWhoWereYouRaised_Parents' name='rbByWhoWereYouRaised' className='add-only' value='Parents'/> Parents &nbsp; &nbsp;
    <input type='radio' id='rbByWhoWereYouRaised_Grandparents' name='rbByWhoWereYouRaised' className='add-only' value='Grandparents'/> Grandparents &nbsp; &nbsp;
    <input type='radio' id='rbByWhoWereYouRaised_Relatives' name='rbByWhoWereYouRaised' className='add-only' value='Relatives'/> Relatives &nbsp; &nbsp;
    <input type='radio' id='rbByWhoWereYouRaised_FosterCare' name='rbByWhoWereYouRaised' className='add-only' value='FosterCare'/> Friend &nbsp; &nbsp;
</p>

<p className='w-750'><span className='eleHeader'>Are your parents/guardian living or deceased:</span>
    <input type='radio' id='rbAreParentsLivingDeceased_Living' name='rbAreParentsLivingDeceased' className='add-only' value='Living'/> Living (M/F) &nbsp; &nbsp;
    <input type='radio' id='rbAreParentsLivingDeceased_Deceased' name='rbAreParentsLivingDeceased' className='add-only' value='Deceased'/> Deceased(M/F)&nbsp; &nbsp;

</p>

<p className='w-750'><span className='eleHeader'>Did you experience any traumatic events during your childhood (i.e., deaths, abuse, etc.)</span>
    <input type='radio' id='rbDidYouExperienceAnyTraumaticDuring_Yes' name='rbDidYouExperienceAnyTraumaticDuring' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDidYouExperienceAnyTraumaticDuring_No' name='rbDidYouExperienceAnyTraumaticDuring' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_4' name='txtIfYesExplain_4' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Number of siblings:</span>
    <input type='text' id='txtNumberOfSiblings_1' name='txtNumberOfSiblings_1' className='add-only w-200  custom-add-only'/>&nbsp; sister and
    &nbsp;
    <input type='text' id='txtNumberOfSiblings_2' name='txtNumberOfSiblings_2' className='add-only w-200  custom-add-only'/>&nbsp; brothers
</p>

<p className='w-750'>
    <span className='eleHeader'>Is your relationship with your siblings close or distant? Explain:</span>
    <textarea id='txtIsYourRelationshipWithYour' name='txtIsYourRelationshipWithYour' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>How would you describe your relationship with your father?</span>
    <input type='radio' id='rbHowWouldYourDescribeYour_Close' name='rbHowWouldYourDescribeYour' className='add-only' value='Close'/> Close &nbsp;
    <input type='radio' id='rbHowWouldYourDescribeYour_Distant' name='rbHowWouldYourDescribeYour' className='add-only' value='Distant'/> Distant <br />

    <span className='eleHeader'>Explain what made it close or distant:</span>
    <textarea id='txtExplainWhatMadeItClose' name='txtExplainWhatMadeItClose' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>How would you describe your relationship with your mother? </span>
    <input type='radio' id='rbHowWouldYouDescribeYourRelationship_Close' name='rbHowWouldYouDescribeYourRelationship' className='add-only' value='Close'/> Close &nbsp;
    <input type='radio' id='rbHowWouldYouDescribeYourRelationship_Distant' name='rbHowWouldYouDescribeYourRelationship' className='add-only' value='Distant'/> Distant <br />

    <span className='eleHeader'>Explain what made it close or distant:</span>
    <textarea id='txtExplainWhatMadeItClose_1' name='txtExplainWhatMadeItClose_1' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Were you or any of your siblings physically, psychologically, or sexually abused as children? </span>
    <input type='radio' id='rbWereYouOrAnySiblings_Yes' name='rbWereYouOrAnySiblings' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWereYouOrAnySiblings_No' name='rbWereYouOrAnySiblings' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>By whom?</span>
    <textarea id='txtByWhom' name='txtByWhom' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>What was the impact emotionally and psychologically on the abused? </span>
    <textarea id='txtWhatWasTheImpactEmotionally' name='txtWhatWasTheImpactEmotionally' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Did you have any problems with anger or violent behavior as a child or teenager? </span>
    <input type='radio' id='rbDidYouHaveAnyProblemsWithAnger_Yes' name='rbDidYouHaveAnyProblemsWithAnger' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDidYouHaveAnyProblemsWithAnger_No' name='rbDidYouHaveAnyProblemsWithAnger' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, please explain:</span>
    <textarea id='txtIfYesPleaseExplain_1' name='txtIfYesPleaseExplain_1' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Were there any other events or circumstances regarding your childhood that may help us understand your particular counseling needs?</span>
    <input type='radio' id='rbWereThereAnyOtherEvents_Yes' name='rbWereThereAnyOtherEvents' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWereThereAnyOtherEvents_No' name='rbWereThereAnyOtherEvents' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_5' name='txtIfYesExplain_5' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Did you ever see your father or mother physically or psychologically abuse each other?</span>
    <input type='radio' id='rbDidYouEverSeeYourFatherMother_Yes' name='rbDidYouEverSeeYourFatherMother' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbDidYouEverSeeYourFatherMother_No' name='rbDidYouEverSeeYourFatherMother' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, explain:</span>
    <textarea id='txtIfYesExplain_6' name='txtIfYesExplain_6' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>What impact did seeing/hearing one of your parents abuse the other have on you emotionally, psychologically, or physically?</span>
    <textarea id='txtIfYesExplain_6' name='txtIfYesExplain_6' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Please tell me about any concerns you or others have about your anger.</span>
    <textarea id='txtPleaseTellMeAboutAnyConcernsYou' name='txtPleaseTellMeAboutAnyConcernsYou' className='add-only'></textarea>
</p>

<p className='w-750'><h3>ANGER/VIOLENCE HISTORY MOST RECENT ANGER EPISODE</h3></p>

<p className='w-750'>
    <span className='eleHeader'>Please describe in detail your most recent anger incident:  With whom? How did it end?</span>
    <textarea id='txtPleaseDescribeInDetailYourMostRecentAnger' name='txtPleaseDescribeInDetailYourMostRecentAnger' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>What actions did you demonstrate during the angry episode? </span>
    <input type='radio' id='rbWhatActionsDidYouDemonstrate_Physical' name='rbWhatActionsDidYouDemonstrate' className='add-only' value='Physical'/> Physical &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrate_Verbal' name='rbWhatActionsDidYouDemonstrate' className='add-only' value='VerbalThreats'/> Verbal Threats  &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrate_Property' name='rbWhatActionsDidYouDemonstrate' className='add-only' value='PropertyDestruction'/> Property destruction  &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrate_Other' name='rbWhatActionsDidYouDemonstrate' className='add-only' value='Other'/> Other &nbsp; &nbsp; <br />

    <span className='eleHeader'>Explain:</span>
    <textarea id='txtExplain_2' name='txtExplain_2' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Explain how did you feel physically while you were angry? </span>
    <input type='radio' id='rbExplainHowDidYouFeelAngry_Tense' name='rbExplainHowDidYouFeelAngry' className='add-only' value='Tense'/> Tense &nbsp; &nbsp;
    <input type='radio' id='rbExplainHowDidYouFeelAngry_Rush' name='rbExplainHowDidYouFeelAngry' className='add-only' value='Rush'/> Rush &nbsp; &nbsp;
    <input type='radio' id='rbExplainHowDidYouFeelAngry_Strong' name='rbExplainHowDidYouFeelAngry' className='add-only' value='Strong'/> Property destruction  &nbsp; &nbsp;
    <input type='radio' id='rbExplainHowDidYouFeelAngry_None' name='rbExplainHowDidYouFeelAngry' className='add-only' value='None'/> None &nbsp; &nbsp; <br />

    <input type='radio' id='rbExplainHowDidYouFeelAngry_Other' name='rbExplainHowDidYouFeelAngry' className='add-only' value='Other'/> Other &nbsp;
    <input type='text' id='txtExplainHowDidYouFeelAngry' name='txtExplainHowDidYouFeelAngry' className='add-only w-375  custom-add-only'/>
</p>

<p className='w-750'><span className='eleHeader'>Were there any use of alcohol and/or drugs by anyone involved?</span>
    <input type='radio' id='rbWereThereAnyUseOfAlcohol_Yes' name='rbWereThereAnyUseOfAlcohol' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWereThereAnyUseOfAlcohol_No' name='rbWereThereAnyUseOfAlcohol' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, by whom?</span>
    <textarea id='txtIfYesByWhom' name='txtIfYesByWhom' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Was this incident typical?</span>
    <input type='radio' id='rbWasThisIncidentTypical_Yes' name='rbWasThisIncidentTypical' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbWasThisIncidentTypical_No' name='rbWasThisIncidentTypical' className='add-only' value='No'/> No
</p>

<p className='w-750'><h4>EXPLAIN YOUR WORST ANGER EPISODE</h4></p>

<p className='w-750'>
    <span className='eleHeader'>When and with whom were involved? What happened?  How did this angry episode start? How did it end?</span>
    <textarea id='txtWhenAndWithWhomWereInvolved' name='txtWhenAndWithWhomWereInvolved' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>Any alcohol or drugs by anyone involved? </span>
    <input type='radio' id='rbAnyAlcoholOrDrugsInvolved_Yes' name='rbAnyAlcoholOrDrugsInvolved' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbAnyAlcoholOrDrugsInvolved_No' name='rbAnyAlcoholOrDrugsInvolved' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, who was using?</span>
    <textarea id='txtIfYesByWhom_1' name='txtIfYesByWhom_1' className='add-only'></textarea>
</p>

<p className='w-750'><span className='eleHeader'>What actions did you demonstrate during the angry episode? </span>
    <input type='radio' id='rbWhatActionsDidYouDemonstrateDuringTheAngry_Physical' name='rbWhatActionsDidYouDemonstrateDuringTheAngry' className='add-only' value='Physical'/> Physical &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrateDuringTheAngry_Verbal ' name='rbWhatActionsDidYouDemonstrateDuringTheAngry' className='add-only' value='Verbal'/> Verbal  &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrateDuringTheAngry_Threats' name='rbWhatActionsDidYouDemonstrateDuringTheAngry' className='add-only' value='Threats'/> Threats &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrateDuringTheAngry_Property' name='rbWhatActionsDidYouDemonstrateDuringTheAngry' className='add-only' value='Property'/> Property destruction  &nbsp; &nbsp;
    <input type='radio' id='rbWhatActionsDidYouDemonstrateDuringTheAngry_Other' name='rbWhatActionsDidYouDemonstrateDuringTheAngry' className='add-only' value='Other'/> Other &nbsp;<br />

    <span className='eleHeader'>Explain:</span>
    <textarea id='txtExplain_3' name='txtExplain_3' className='add-only'></textarea>
</p>

<p className='w-750'><h4>Duration:</h4></p>

<p className='w-750'>
    <span className='eleHeader'>When you become angry, how long do you remain angry? </span>
    <input type='text' id='txtWhenYouBecomeAngryHowAngry' name='txtWhenYouBecomeAngryHowAngry' className='add-only'/>
</p>

<p className='w-750'><h4>Intensity:</h4></p>

<p className='w-750'>
    <span className='eleHeader'>On a scale of 1 to 10, with one representing no anger and 10 representing explosive anger, rate the intensity of your anger during the angry episode</span>
    <input type='text' id='txtOnAScaleOfWithOneRepresentingAnger' name='txtOnAScaleOfWithOneRepresentingAnger' className='add-only'/>
</p>

<p className='w-750'><h4>Frequency:</h4></p>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>How often have you had trouble with your anger:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_ThisTime' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='ThisTimeOnly'/> This time only
        </td>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_ThisMonth' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='ThisMonthOnly'/> This month only
        </td>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_LastSix' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='LastSixMonths'/> Last six months
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_Childhood' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='SinceChildhood'/> Since childhood
        </td>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_Adolescent' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='Adolescent'/> Adolescent
        </td>
        <td className='w-250'>
            <input type='radio' id='rbHowOftenHaveYouHadTrouble_OnlyAdult' name='rbHowOftenHaveYouHadTrouble' className='add-only' value='OnlyAdult'/> Only as an adult
        </td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Would you say that lately you become angry</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbWouldYouSayThatLatelyYou_MoreOften' name='rbWouldYouSayThatLatelyYou' className='add-only' value='MoreOften'/> more often than a year ago?
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWouldYouSayThatLatelyYou_LessOften' name='rbWouldYouSayThatLatelyYou' className='add-only' value='LessOften'/> less often than a year ago?
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWouldYouSayThatLatelyYou_AboutThe' name='rbWouldYouSayThatLatelyYou' className='add-only' value='AboutThe'/> about the same as a year ago?
        </td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Would you say that lately when you become angry you have</span></td>
    </tr>
    <tr>
        <td className='w-500'>
            <input type='radio' id='rbWouldYouSayThatLatelyWhenYouBeomeAngry_MoreControl' name='rbWouldYouSayThatLatelyWhenYouBeomeAngry' className='add-only' value='MoreControl'/> more control than previously over what you say and do?
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWouldYouSayThatLatelyWhenYouBeomeAngry_LessControl' name='rbWouldYouSayThatLatelyWhenYouBeomeAngry' className='add-only' value='LessControl'/> less control?
        </td>

    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>When upset are you more likely to become angry at</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbWhenUpsetAreYou_Other' name='rbWhenUpsetAreYou' className='add-only' value='Others'/> others?
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWhenUpsetAreYou_Yourself' name='rbWhenUpsetAreYou' className='add-only' value='Yourself?'/> yourself?
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWhenUpsetAreYou_BothYourself' name='rbWhenUpsetAreYou' className='add-only' value='BothYourself'/> both yourself and others
        </td>
    </tr>
</table>

<p className='w-750'><h4>Immediate Stressors:</h4></p>

<p className='w-750'>
    <span className='eleHeader'>A.  What occurred in your life now or in the past several months that has caused you stress, concern, or anxiety?</span>
    <textarea id='txtWhatOccurredInYourLifeNow' name='txtWhatOccurredInYourLifeNow' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Financial troubles:</span>
    <input type='text' id='txtFinancialTroubles' name='txtFinancialTroubles' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Relationship problems:</span>
    <input type='text' id='txtRelationshipProblems' name='txtRelationshipProblems' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Health concerns:</span>
    <input type='text' id='txtHealthConcerns' name='txtHealthConcerns' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Job or school difficulties:</span>
    <input type='text' id='txtJobOrSchoolDifficulties' name='txtJobOrSchoolDifficulties' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Legal issues:</span>
    <input type='text' id='txtLegalIssues' name='txtLegalIssues' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Emotional problems: </span>
    <input type='text' id='txtEmotionalProblems' name='txtEmotionalProblems' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Concern about someone else: </span>
    <input type='text' id='txtConcernAboutSomeone' name='txtConcernAboutSomeone' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Religious or spiritual issues </span>
    <input type='text' id='txtReligiousOrSpiritualIssues' name='txtReligiousOrSpiritualIssues' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Other (specify):</span>
    <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only'/>
</p>

<p className='w-750'><h4>WITH WHOM DO YOU GET ANGRY</h4></p>

<table>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Partner' name='rbWithWhomDoYouGet' className='add-only' value='Partner'/> Partner
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Parents' name='rbWithWhomDoYouGet' className='add-only' value='ParentsStepParents'/> Parents/Step-Parents
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Children' name='rbWithWhomDoYouGet' className='add-only' value='YourChildren'/> Your children (step-children)
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Relatives' name='rbWithWhomDoYouGet' className='add-only' value='Relatives'/> Relatives
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Employer' name='rbWithWhomDoYouGet' className='add-only' value='Employer'/> Employer/Co-workers
        </td>
        <td className='w-250'>
            <input type='radio' id='rbWithWhomDoYouGet_Friends' name='rbWithWhomDoYouGet' className='add-only' value='Friends'/> Friends
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='radio' id='rbWithWhomDoYouGet_Other' name='rbWithWhomDoYouGet' className='add-only' value='Other'/> Other &nbsp;
            <input type='text' id='txtWithWhomeDoYouGet_1' name='txtWithWhomeDoYouGet_1' className='add-only w-375 custom-add-only'/>
        </td>
    </tr>
</table>

<p className='w-750'>
    <span className='eleHeader'>What about?</span>
    <textarea id='txtWhatAbout' name='txtWhatAbout' className='add-only'></textarea>
</p>

<p className='w-750'><h4>FAMILY OF ORIGIN</h4>
    Describe what the following people do/did with their anger, especially when you were growing up:</p>

<p className='w-750'>
    <span className='eleHeader'>Your father/stepfather:  </span>
    <textarea id='txtYourFather' name='txtYourFather' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Your mother/stepmother:</span>
    <textarea id='txtYourMother' name='txtYourMother' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Your brother/sisters:</span>
    <textarea id='txtYourBrother' name='txtYourBrother' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Other significant persons (grandparents, etc.)  NA</span>
    <textarea id='txtOtherSignificant' name='txtOtherSignificant' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Is there any family history of bad temper, assaults, homicides or suicides? </span>
    <textarea id='txtIsThereAnyFamilyHistory' name='txtIsThereAnyFamilyHistory' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Were you physically or sexually assaulted?  If so, how do you think that has affected you, especially in terms of anger?</span>
    <textarea id='txtWereYouPhysicallySexually' name='txtWereYouPhysicallySexually' className='add-only'></textarea>
</p>

<p className='w-750'><h4>ANY CURRENT PROBLEMS WITH OR HISTORY OF: NA</h4>
    <span className='eleHeader'>Problem:</span></p>

<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Brain' name='rbAnyCurrentProblemsWith' className='add-only' value='Brain'/> Brain injury <br />
    <input type='text' id='txtAnyCurrentProblemsWith_1' name='txtAnyCurrentProblemsWith_1' className='add-only'/>
</p>

<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Stroke' name='rbAnyCurrentProblemsWith' className='add-only' value='Stroke'/> Stroke <br />
    <input type='text' id='txtAnyCurrentProblemsWith_2' name='txtAnyCurrentProblemsWith_2' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Epilepsy' name='rbAnyCurrentProblemsWith' className='add-only' value='Epilepsy'/> Epilepsy/Seizures<br />
    <input type='text' id='txtAnyCurrentProblemsWith_3' name='txtAnyCurrentProblemsWith_3' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_AttentionDeficit' name='rbAnyCurrentProblemsWith' className='add-only' value='AttentionDeficit'/> Attention Deficit Disorder<br />
    <input type='text' id='txtAnyCurrentProblemsWith_4' name='txtAnyCurrentProblemsWith_4' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Premenstrual' name='rbAnyCurrentProblemsWith' className='add-only' value='Premenstrual'/> Premenstrual Syndrome<br />
    <input type='text' id='txtAnyCurrentProblemsWith_5' name='txtAnyCurrentProblemsWith_5' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Depression' name='rbAnyCurrentProblemsWith' className='add-only' value='Depression'/> Depression <br />
    <input type='text' id='txtAnyCurrentProblemsWith_6' name='txtAnyCurrentProblemsWith_6' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_Ptsd' name='rbAnyCurrentProblemsWith' className='add-only' value='Ptsd'/> PTSD <br />
    <input type='text' id='txtAnyCurrentProblemsWith_7' name='txtAnyCurrentProblemsWith_7' className='add-only'/>
</p>
<p className='w-750'>
    <input type='radio' id='rbAnyCurrentProblemsWith_OtherSerious' name='rbAnyCurrentProblemsWith' className='add-only' value='OtherSerious'/> Other serious illness <br />
    <input type='text' id='txtAnyCurrentProblemsWith_8' name='txtAnyCurrentProblemsWith_8' className='add-only'/>
</p>

<p className='w-750'><span className='eleHeader'>Are you currently taking any medications:</span>
    <input type='radio' id='rbAreYouCurrentlyTakingMedications_Yes' name='rbAreYouCurrentlyTakingMedications' className='add-only' value='Yes'/> Yes &nbsp;
    <input type='radio' id='rbAreYouCurrentlyTakingMedications_No' name='rbAreYouCurrentlyTakingMedications' className='add-only' value='No'/> No <br />

    <span className='eleHeader'>If yes, what are you taking?</span>
    <textarea id='txtIfYesWhatAreYouTaking' name='txtIfYesWhatAreYouTaking' className='add-only'></textarea>
</p>

<p className='w-750'><h4>LEGAL HISTORY RELATING TO ANGER/AGGRESSION</h4></p>

<p className='w-750'>
    <span className='eleHeader'>Current legal problems related to anger/aggression:</span>
    <input type='text' id='txtCurrentLegalProblems' name='txtCurrentLegalProblems' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>Past legal problems related to anger/aggression</span>
    <input type='text' id='txtPastLegalProblemsRelated' name='txtPastLegalProblemsRelated' className='add-only'/>
</p>

<p className='w-750'><span className='eleHeader'>HOW HAVE YOU ATTEMPTED TO CONTROL YOUR ANGER?</span></p>

<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_GoSelf' name='rbHowHaveAttemptedControl' className='add-only' value='INeverHave'/> I never have<br />
</p>


<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_Talk' name='rbHowHaveAttemptedControl' className='add-only' value='TalkToMySelf'/> Talk to myself.  What do you say to yourself to control your anger?  <br />
    <input type='text' id='txtHowHaveAttemptedControl_1' name='txtHowHaveAttemptedControl_1' className='add-only'/>
</p>

<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_Leave' name='rbHowHaveAttemptedControl' className='add-only' value='LeaveTheScence'/> Leave the scene. &nbsp; How long? &nbsp;
    <input type='text' id='txtHowHaveAttemptedControl_2' name='txtHowHaveAttemptedControl_2' className='add-only w-200 custom-add-only'/> <br />
    What do you do?
    <input type='text' id='txtHowHaveAttemptedControl_3' name='txtHowHaveAttemptedControl_3' className='add-only'/>
</p>

<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_TryToRelax' name='rbHowHaveAttemptedControl' className='add-only' value='TryToRelax'/> Try to relax.<br />
    How?
    <input type='text' id='txtHowHaveAttemptedControl_4' name='txtHowHaveAttemptedControl_4' className='add-only'/>
</p>

<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_GoSelf' name='rbHowHaveAttemptedControl' className='add-only' value='GoSelfHelp'/> Go to a self help group such as A.A.<br />
</p>

<p className='w-750'>
    <input type='radio' id='rbHowHaveAttemptedControl_Other' name='rbHowHaveAttemptedControl' className='add-only' value='Other'/> Other?<br />
    What?
    <input type='text' id='txtHowHaveAttemptedControl_5' name='txtHowHaveAttemptedControl_5' className='add-only'/>
</p>

<p className='w-750'>
    <span className='eleHeader'>What do you think is the first thing you need to do to help you control your anger?</span>
    <textarea id='txtWhatDoYouThinkIsControlAnger' name='txtWhatDoYouThinkIsControlAnger' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>What else do you need to do?</span>
    <textarea id='txtWhatElseDoYouNeed' name='txtWhatElseDoYouNeed' className='add-only'></textarea>
</p>

<p className='w-750'>
    <span className='eleHeader'>Is there anything else you can tell me that might help me understand your anger and how it affects you and others?     </span>
    <textarea id='txtIsThereAnythingUnderstand' name='txtIsThereAnythingUnderstand' className='add-only'></textarea>
</p>

<p className='w-750'><h4>Recommendation:</h4>
    <span className='eleHeader'>What would you like to change or learn as a result of counseling?</span>
    1. <input type='text' id='txtRecommendation_1' name='txtRecommendation_1' className='add-only w-700 custom-add-only'/><br />
    2. <input type='text' id='txtRecommendation_2' name='txtRecommendation_2' className='add-only w-700 custom-add-only'/><br />
    3. <input type='text' id='txtRecommendation_3' name='txtRecommendation_3' className='add-only w-700 custom-add-only'/><br />
</p>

<table>
    <tr>
        <td className='signature w-500'>&nbsp; </td>
        <td className='signature w-250'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-500'>Clinician Signature:</td>
        <td className='small w-250'>Date</td>
    </tr>
</table>

            


            </div>
        </form>

    )
}  
